import React, { useEffect, useState } from 'react';
import i18next from 'i18next';
import useStyles from "../../style/js-style/containers/thirdparties/unmanagedThirdParty/CreateUnmanagedThirdPartyStyle";
import { getShownValues } from './unmanagedThirdParty/UnmanagedThirdPartyUtils';
import EAColorIcon from '../common/EAColorIcon';
import { MODE } from '../attributes/Attributes';
import Attribute from '../attributes/Attributes';
import { useGetOffsetSize } from '../hook/useGetOffsetSize';

function AttributesStep({ formMethods, bondType }) {
  const { classes } = useStyles();
  const [selectedAttribute, setSelectedAttribute] = useState();
  const watchAttributes = formMethods.watch("attributes");
  const [myRef, size] = useGetOffsetSize();

  // Modifie la valeur de l'attribut puis ferme la pop-up
  const handleSubmit = (data) => {
    const newAttributes = watchAttributes.map((item, index) => {
      return index === selectedAttribute.index
        ? {
            ...item,
            values: data.values || (data.value ? [data.value ] : []),
            shownValues: getShownValues({ ...data, type: item.type }),
          }
        : item;
    })

    formMethods.setValue("attributes", newAttributes);
    setSelectedAttribute(null);
  }

  // Vérifie les erreurs pour les attributs obligatoires
  useEffect(() => {
    watchAttributes.forEach((attribute, index) => {
      if (attribute.isRequired && !attribute.values?.length) {
        formMethods.setError(`attributes.${index}`, {
          type: 'manual',
          message: i18next.t("infos.required")
        });
      } else {
        formMethods.clearErrors(`attributes.${index}`);
      }
    })
  }, [watchAttributes, formMethods]);

  return (
    <div className={classes.mainContentWrapper}>
      <div className={classes.formPartWrapper}>

        <div className={classes.formPartTitleAttributes}>
          <EAColorIcon icon={'thirdparty-label_green'} width={30} svgStyle={{position: "relative", top: "20px"}}/>
          {i18next.t('unmanagedThirdParty.thirdPartyAttributes')}
        </div>

        <div className={classes.formPartContent}>
          <div className={classes.formContainerAttributes} ref={myRef}>
            { watchAttributes.length > 0 && watchAttributes.map((attribute, index) =>
              <Attribute
                mode={MODE.create}
                attribute={attribute}
                index={index}
                formMethods={formMethods}
                customHandleSubmit={handleSubmit}
                isEditAttribute={selectedAttribute?.index === index}
                setSelectedAttribute={setSelectedAttribute}
                bondType={bondType}
                key={index}
                sizeOfWrapper={size}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default AttributesStep;
